import { z } from '../index.ts'

export const GetUpdateHistorySchema = z.object({
  field: z.string(),
  updated_at: z.coerce.date(),
  value: z.string().nullish(),
})
